import { RouteObject } from "react-router-dom";
import { SmartRedirect } from './SmartRedirect';
import { ROUTESPATH } from '../constant';


// Feature Pages
import { AnalyticsPage } from '@/features/analytics/routes';
import { CreditControlPageAntd } from '@/features/credit-control/routes';
import { CustomerListPage, CustomerDetailsPage } from '@/features/customers/routes';
import { DashboardPage } from '@/features/dashboard/routes';
import { DepotsPage } from '@/features/depots/routes';
import { IssuesPage } from '@/features/issues/routes';
import { JobsPage } from '@/features/jobs/routes';
import { OnboardingPage, CustomerDiscountPage } from '@/features/onboarding/routes';
import { OrdersManagementPage, OrderDetailPage } from '@/features/orders-management/routes';
import { ProductConfiguratorPage } from '@/features/product-configurator/routes';
import { QuoteDetailPage, QuotesManagementPage } from '@/features/quotes-management/routes';
import { PermissionsPage, SettingsPage } from '@/features/settings/routes';
import { UserManagementPageAntd } from '@/features/users/routes';
import { CurrencyExchangePage } from '@/features/currency-exchange/routes';
import { DeliverySettingsPage } from '@/features/delivery-settings/routes';
import { Unauthorized } from '@/features/common/Unauthorized';
import { Deactivated } from '@/features/common/Deactivated';
import { ProtectedRoute } from '@/routes/appRoutes/ProtectedRoute';
import { lazyImport } from "@/utils/lazyImport";
import { PrivateTemplate } from "./privateTemplate";
const { Layout } = lazyImport(
  () => import("@/features/layout/layout"),
  "Layout"
);
export const privateRoutes: RouteObject[] = [
  {
    element: <PrivateTemplate />,
    children: [
      {
        path: ROUTESPATH.ROOT,
        element: (
          <Layout />
        ),
        children: [
          {
            index: true,
            element: <SmartRedirect />,
          },
          {
            path: ROUTESPATH.UNAUTHORIZED,
            element: <Unauthorized />,
          },
        
          {
            path: ROUTESPATH.DASHBOARD,
            element: (
              <ProtectedRoute requiredPermission="view_dashboard">
                <DashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.JOBS,
            element: <JobsPage />,
          },
          {
            path: ROUTESPATH.QUOTES,
            element: (
              <ProtectedRoute requiredPermission="view_quotes">
                <QuotesManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.ORDERS,
            element: (
              <ProtectedRoute requiredPermission="view_orders">
                <OrdersManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.ORDER_DETAIL,
            element: (
              <ProtectedRoute requiredPermission="view_orders">
                <OrderDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.QUOTE_DETAIL,
            element: (
              <ProtectedRoute requiredPermission="view_quotes">
                <QuoteDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.ISSUES,
            element: <IssuesPage />,
          },
          {
            path: ROUTESPATH.CUSTOMERS,
            element: (
              <ProtectedRoute requiredPermission="view_customers">
                <CustomerListPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.CUSTOMER_DETAIL,
            element: (
              <ProtectedRoute requiredPermission="view_customers">
                <CustomerDetailsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.INSTALLERS,
            element: (
              <ProtectedRoute requiredPermission="view_customers">
                <CustomerListPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.USERMANAGEMENT,
            element: (
              <ProtectedRoute requiredPermission="view_users">
                <UserManagementPageAntd />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.DEPOTS,
            element: (
              <ProtectedRoute requiredPermission="view_depots">
                <DepotsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.ONBOARDING,
            element: (
              <ProtectedRoute requiredPermission="view_onboarding">
                <OnboardingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.CUSTOMER_DISCOUNT,
            element: (
              <ProtectedRoute requiredPermission="view_onboarding">
                <CustomerDiscountPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.CREDIT_CONTROL,
            element: (
              <ProtectedRoute requiredPermission="view_credit_control">
                <CreditControlPageAntd />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.CURRENCY_EXCHANGE,
            element: (
              <ProtectedRoute requiredPermission="view_currency_exchange">
                <CurrencyExchangePage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.PRODUCT_CONFIGURATOR,
            element: (
              <ProtectedRoute requiredPermission="view_product_configurator">
                <ProductConfiguratorPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.ANALYTICS,
            element: (
              <ProtectedRoute requiredPermission="view_analytics">
                <AnalyticsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.SETTINGS,
            element: (
              <ProtectedRoute requiredPermission="view_settings">
                <SettingsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.DELIVERY_SETTINGS,
            element: (
              <ProtectedRoute requiredPermission="view_settings">
                <DeliverySettingsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ROUTESPATH.PERMISSIONS,
            element: (
              <ProtectedRoute requiredPermission="view_permissions">
                <PermissionsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: '*',
            element: <SmartRedirect />,
          },
        ],
      },
    ]
  }

];
